var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('md-button',{staticClass:"md-primary",staticStyle:{"min-width":"40%","height":"35px"},on:{"click":function($event){return _vm.apply()}}},[_vm._v(_vm._s(_vm.$t("investor.exchange.table.operation.bid.button"))+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }